import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import DashboardTile from '../DashboardTile';
import { getProjects } from '../../services/projectService';
import { getMemberships } from '../../services/membershipService';
import { getClaims } from '../../services/membershipService';

const CommunityDashboard = () => {
  const { user, activeTenant } = useAuth();
  const [stats, setStats] = useState({ projects: null, members: null, pendingClaims: null });

  const tenantId = activeTenant?._id;

  useEffect(() => {
    if (!tenantId) return;
    let alive = true;
    Promise.allSettled([
      getProjects({ tenantId }),
      getMemberships({ tenantId, status: 'active' }),
      getClaims({ tenantId, status: 'pending' }),
    ]).then(([projRes, memRes, claimRes]) => {
      if (!alive) return;
      setStats({
        projects:      projRes.status  === 'fulfilled' ? (projRes.value.data?.length  ?? '?') : '?',
        members:       memRes.status   === 'fulfilled' ? (memRes.value.data?.length   ?? '?') : '?',
        pendingClaims: claimRes.status === 'fulfilled' ? (claimRes.value.data?.length ?? '?') : '?',
      });
    });
    return () => { alive = false; };
  }, [tenantId]);

  const communityName = activeTenant?.branding?.displayName || activeTenant?.name || 'Your Community';

  const tiles = [
    { title: 'Projects',          icon: '📁', description: 'View and manage community projects',       path: '/community-admin', color: '#4285F4' },
    { title: 'Members',           icon: '👥', description: 'Community member directory and roles',     path: '/community-admin', color: '#0F9D58' },
    { title: 'Membership Claims', icon: '📋', description: 'Review pending membership applications',   path: '/community-admin', color: '#F4B400', badge: typeof stats.pendingClaims === 'number' && stats.pendingClaims > 0 ? stats.pendingClaims : undefined },
    { title: 'Community News',    icon: '📰', description: 'Post announcements and news updates',      path: '/community-news',  color: '#FF5722' },
    { title: 'Consultations',     icon: '💬', description: 'Active consultation projects',             path: '/consultation',    color: '#9C27B0' },
    { title: 'Community Data',    icon: '📂', description: 'Community-submitted data entries',         path: '/community-data',  color: '#00BCD4' },
    { title: 'Questionnaires',    icon: '📝', description: 'Create and manage community surveys',      path: '/questionnaires',  color: '#8BC34A' },
    { title: 'Branding & Config', icon: '🎨', description: 'Customize your community appearance',     path: '/community-admin', color: '#607D8B' },
  ];

  return (
    <div className="panel-dashboard">
      <div className="panel-dashboard__header">
        <div>
          <h1>{communityName}</h1>
          <p>Community Admin · {user?.firstName || user?.email}</p>
        </div>
        <Link to="/community-admin" className="btn btn--primary">Community Admin Panel →</Link>
      </div>

      {tenantId && (
        <div className="admin-stats-row">
          <div className="admin-stat-card" style={{ borderLeftColor: '#4285F4' }}>
            <span className="admin-stat-value">{stats.projects ?? '—'}</span>
            <span className="admin-stat-label">Projects</span>
          </div>
          <div className="admin-stat-card" style={{ borderLeftColor: '#0F9D58' }}>
            <span className="admin-stat-value">{stats.members ?? '—'}</span>
            <span className="admin-stat-label">Active Members</span>
          </div>
          <div className="admin-stat-card" style={{ borderLeftColor: '#F4B400' }}>
            <span className="admin-stat-value">{stats.pendingClaims ?? '—'}</span>
            <span className="admin-stat-label">Pending Claims</span>
          </div>
        </div>
      )}

      <h2 className="panel-dashboard__section-title">Community Tools</h2>
      <div className="tile-grid">
        {tiles.map((t) => <DashboardTile key={t.title} {...t} />)}
      </div>
    </div>
  );
};

export default CommunityDashboard;
